import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom/client';
import { useDispatch, useSelector } from 'react-redux';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Modal, ModalProvider } from './components/modals/modal';

import { store } from './store';
import { restoreUser } from './store/session';

import LandingPageComponent from './components/landing_page';
import HomeComponent from './components/home_page';
import ErrorComponent from './components/error_page';

import './index.css';

let environment = process.env.REACT_APP_ENVIRONMENT || '';

if (typeof window !== 'undefined' && navigator) {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/Win/i.test(userAgent)) {
        environment = process.env.REACT_APP_LOCAL_ENVIRONMENT;
    } else {
        environment = process.env.REACT_APP_ENVIRONMENT;
    };
};

if (environment === 'development') {
    store.subscribe(() => {
      console.log("Redux state:", store.getState());
    });
};

const AppWrapper = () => {
	const dispatch = useDispatch();
  const [authLoaded, setAuthLoaded] = useState(false);
  const [minimumDelayElapsed, setMinimumDelayElapsed] = useState(false);
  useSelector(state => state.session.user);

  	const fetchAuth = useCallback(async () => {
    await dispatch(restoreUser());
    setAuthLoaded(true);
    }, [dispatch]);

    useEffect(() => {
    fetchAuth();
  }, [fetchAuth]);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setMinimumDelayElapsed(true);
    }, 4000);

    return () => window.clearTimeout(timer);
  }, []);

  if (!authLoaded || !minimumDelayElapsed) return <LandingPageComponent />

  return (
    <>
		<Outlet />
	</>
  );
};



const router = createBrowserRouter([
  {
    path: "/",
	element: <AppWrapper />,
    children: [
      { index: true, element: <HomeComponent /> },
      { path: "/account", element: <HomeComponent /> },
      { path: "/admin", element: <HomeComponent /> },
      { path: "/character/*", element: <HomeComponent />},
      // { path: "about", element: <HomeComponent /> },
      // { path: "contact", element: <HomeComponent /> },
      { path: "*", element: <ErrorComponent /> },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ModalProvider>
        <RouterProvider router={router} />
        <Modal />
      </ModalProvider>
    </Provider>
  </React.StrictMode>
);